import cancerDeProstatChange from './cancerDeProstaChange';
/*
   Constante de servico criado para customizar eventos via js, vai existir necessidade de alteracao de layout e de customizacao para cada linha de cudiado
*/
const customChangeService = (fields, careLine) => {
  switch (careLine) {
    case 'cancer_de_prostata':
      cancerDeProstatChange(fields);
    default:
      return;
  }
};

export default customChangeService;
